import {bff} from '../bff-hooks'

export interface PleoGuideMilestones {
    firstPurchase?: boolean
    accountingSetup?: boolean
    inviteTeam?: boolean
}

export const usePleoGuideMilestones = () => {
    const {data, isLoading, isInitialLoading, error} =
        bff.featureOnboarding.pleoGuide.getPleoGuideMilestones.useQuery()

    const {mutate} = bff.featureOnboarding.pleoGuide.setPleoGuideMilestones.useMutation()

    return {data, mutate, isLoading, isInitialLoading, error}
}
